// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a83b","importantInfo":"styles_importantInfo__T62nm"};